/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';
import { professionEmployeeTypes, retroattivitaMedici, riskCategoryMediciDipendenti } from '../../../common/constants';

function MediciDipendentiQuoteInfo({ mediciDipendentiQuote, setShowGreeniaAI }) {
    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Colpagrave</h5>
                <hr />
                <div>
                    <div>
                        {mediciDipendentiQuote?.quotes?.quotes?.map((quote, index) => (
                            <div className="row" key={index}>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Massimale:
                                            </strong>
                                            {' '}
                                            {quote?.massimale}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Tipo Dipendente:
                                            </strong>
                                            {' '}
                                            {professionEmployeeTypes.find(
                                                (type) => type.id === quote?.employee_type,
                                            )?.name || 'Non specificato'}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Retroattività:
                                            </strong>
                                            {' '}
                                            {retroattivitaMedici.find(
                                                (type) => type.id === quote?.retroactivity
                                                ,
                                            )?.name || 'Non specificato'}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Tipologia Rischio:
                                            </strong>
                                            {' '}
                                            {riskCategoryMediciDipendenti.find(
                                                (type) => type.id === quote?.risk_category
                                                ,
                                            )?.name || 'Non specificato'}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Prezzo:
                                            </strong>
                                            {' '}
                                            {quote?.price}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <hr />
                                </div>
                            </div>
                        ))}

                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/rc-professionale-sanita/medici-dipendenti/${mediciDipendentiQuote?.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediciDipendentiQuoteInfo;
